import React, { useContext } from 'react';

import QuoterContext from '../context/QuoterContext';

const QuoterHeader = () => {
  const { quoterContextValues } = useContext(QuoterContext);

  return (
    quoterContextValues.ids.idPaso === 6
      ? (
        <div className="quoter-header -result">
          <div className="text-background text-center">GRACIAS</div>
          <div className="inner">
            <h1 className="text-center">{`¡Gracias ${quoterContextValues.form1.Nombre}!`}</h1>
            <p className="text-center">
              Se ha realizado tu pago correctamente. Recibirás por correo electrónico toda la
              información relacionada a tu pago y uno de nuestros ejecutivos se pondrá en contacto
              contigo para comenzar a recibir los beneficios de AMAE®.
            </p>
          </div>
          <div className="scroll-anchor" />
        </div>
      )
      : (
        <div className="quoter-header">
          <div className="text-background text-center">AMAE</div>
          <div className="inner">
            <h1 className="text-center">¡CONTRATAR AMAE® ES MUY FÁCIL!</h1>
            <p className="text-center">Primero, necesitamos que nos des tus datos de contacto</p>
          </div>
          <div className="scroll-anchor" />
        </div>
      )
  );
};

export default QuoterHeader;
